// src/components/tasks/TaskDetailDialog.tsx
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"
import { TaskChat } from "./TaskChat"
import type { ExtendedTask } from "@/types/task"

// === ДИЗАЙН-СЛОЙ ===
import { taskDetailDialogTheme } from "./ui/TaskDetailDialogUI"

interface TaskDetailDialogProps {
  task: ExtendedTask | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function TaskDetailDialog({ task, open, onOpenChange }: TaskDetailDialogProps) {
  if (!task) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={taskDetailDialogTheme.dialogContent}>
        {/* Скрытые заголовок и описание — полностью убирают предупреждения Radix UI */}
        <DialogTitle className="sr-only">Чат задачи: {task.title}</DialogTitle>
        <DialogDescription className="sr-only">
          Чат и детали задачи {task.title} с участниками и файлами
        </DialogDescription>

        {/* Основной чат — возвращаем оригинальный вид и поведение */}
        <TaskChat
          task={task}
          onClose={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}